import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as taskActionTypes from './taskActionTypes';

const byId = handleActions(
  {
    [taskActionTypes.TASK_ACTION_LIST.SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload.entities.taskActions,
    }),
  },
  {},
);

const allIds = handleActions(
  {
    [taskActionTypes.TASK_ACTION_LIST.SUCCESS]: (state, { payload }) => payload.result,
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
